function ReportsData() {
    "use strict";

    this.ReportContainer = 'uReports';
    this.Container = 'uReportFilters';
    this.ReportURLPrepend = 'https://vtreports.veritracks.com/reports/';
    this.CurrentId = -1;
    this.Clean = null;
    this.Sort = null;
    this.Dirty = null;
    this.Paginated = null;
    this.StoredReports = null;
    this.TargetId = -1;
    this.CacheItemsRemaining = 0;
    this.AddReportsReady = false;
    this.SkipUpdateBar = false;
    this.ScheduleFilters = [];
    this.ScheduleEmails = [];
    this.OpeningReportUrl = '';
    this.OpeningReportUrlClose = false;
}
if (typeof exports !== 'undefined') {
    module.exports = ReportsData;
}